export class AppConsts {

    static readonly tenancyNamePlaceHolderInUrl = '{TENANCY_NAME}';
    static readonly sourceApplication = 'Data Platform';
    static readonly catalogTypeClassification = 'CatalogType';
    static readonly supplierCatalogType = 'Supplier';
    

    static remoteServiceBaseUrl: string;
    static remoteServiceBaseUrlFormat: string;
    static appBaseUrl: string;
    static appBaseUrlFormat: string;
    static fileSubmissionSvcUrl: string;
    static fileSubmissionSvcUrlFormat: string;
    static notificationServiceUrl: string;
    static notificationServiceUrlFormat: string;
    static schemaApi: any = null;

    static recaptchaSiteKey: string;
    static subscriptionExpireNootifyDayCount: number;

    static readonly userManagement = {
        defaultAdminUserName: 'admin'
    };

    static readonly localization = {
        defaultLocalizationSourceName: 'Catalyst'
    };

    static readonly authorization = {
        encrptedAuthTokenName: 'enc_auth_token'
    };

    static readonly grid = {
        defaultPageSize: 10
    }

    static readonly regexDefinitions = {
        capitalLetters: /([A-Z])/g,
        multipleSpaceCharacters: /\s+/g
    }
}
